export default "__VITE_ASSET__N1j9Q2Up__"